import { fetchWithAuth } from '../AuthService';
import { DATA_SERVICE_BASE_URL } from '../ApiService';

/**
 * CacheStatsApi
 * Admin endpoints exposed by hibernate-service `CacheStatsController`
 * for inspecting and clearing application-level Caffeine caches.
 *
 * Backend routes:
 *   GET    /api/admin/cache/stats        — per-cache snapshot + Caffeine stats
 *   DELETE /api/admin/cache/{name}       — clear a single cache by name
 *   DELETE /api/admin/cache              — clear ALL caches
 */
export const CacheStatsApi = {
  /**
   * Fetch per-cache snapshot. Response shape:
   * {
   *   [cacheName]: {
   *     maxSize, ttl, notes, size,
   *     stats: { hitCount, missCount, hitRate, loadCount, loadFailureCount,
   *              avgLoadPenaltyNanos, evictionCount, evictionWeight }
   *   }
   * }
   */
  getStats: async () => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/admin/cache/stats`, {
      method: 'GET',
    });
  },

  /** Clear a single cache by name. */
  clearCache: async (name) => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/admin/cache/${encodeURIComponent(name)}`, {
      method: 'DELETE',
    });
  },

  /** Clear all application caches. */
  clearAll: async () => {
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/admin/cache`, {
      method: 'DELETE',
    });
  },
};

export default CacheStatsApi;
